import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ThemeService, LanguageService, Modal } from '@ui-lib';
import { OtpService } from './common/services/otp/otp.service';
import { AuthService } from './common/services/auth/auth.service';

@Component({
  imports: [RouterModule, TranslocoModule, Modal],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected title = 'Cadaa';

  // Services loaded on app initialization
  private readonly themeService = inject(ThemeService);
  private readonly languageService = inject(LanguageService);
  private readonly otpService = inject(OtpService);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    // Clear all OTP-related data on app initialization to ensure a clean state
    this.otpService.clearOtpData();
  }
}
